(function() {
  'use strict'

  function TrackingBar($q, TrackingBarResource) {

    return {

      getProgresso: function(item, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        TrackingBarResource.getProgresso({
            idRastreamento: item,
          }, item).$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          }).
        catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

        return deferred.promise;
      },
    }

  };

  angular
    .module('mandaeApp')
    .factory('TrackingBar', TrackingBar);

}());
